import { format } from "date-fns";
import { nextDate } from "../../../utils/EventoUtils";
import { Status, StatusText } from "../../../utils/Status";
import { VerifyPermits } from "../../../utils/Permisos";
import { useMediaQuery } from "react-responsive";

const TablaEventos = ({
  data,
  setData,
  onClick,
  navigate,
  user,
  setFilter,
  filter,
  setLoading,
}) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  return (
    <div>
      <div
        className="d-none d-md-flex flex-column flex-sm-row justify-content-between align-items-center my-4"
        style={{
          marginLeft: isDesktop ? "10vw" : "0px",
          marginRight: isDesktop ? "10vw" : "0px",
        }}
      >
        <div className="mb-2 mb-sm-0">
          <small className="text-muted">
            Mostrando <span className="fw-medium">EVENTOS {data?.total}</span>
          </small>
        </div>

        <div>
          {data.links.map((link) => {
            if (link.label == "&laquo; Previous") {
              return (
                <label
                  className={`btn btn-outline-dark me-1 ${
                    link.active ? "active" : ""
                  } ${link.url ? "" : "disabled"}`}
                  onClick={() => {
                    let params = {
                      ...filter,
                      page: data.current_page - 1,
                    };

                    setLoading(true);
                    setFilter({
                      ...params,
                    });

                    fetch(setData, params, "/eventos", null, setLoading);
                  }}
                >
                  <i class="bi bi-chevron-left"></i>
                  ANTERIOR
                </label>
              );
            }
            if (link.label == "Next &raquo;") {
              return (
                <label
                  className={`btn btn-outline-dark ${
                    link.active ? "active" : ""
                  } ${link.url ? "" : "disabled"}`}
                  onClick={() => {
                    let params = {
                      ...filter,
                      page: data.current_page + 1,
                    };

                    setLoading(true);
                    setFilter({
                      ...params,
                    });

                    fetch(setData, params, "/eventos", null, setLoading);
                  }}
                >
                  SIGUIENTE
                  <i class="bi bi-chevron-right"></i>
                </label>
              );
            }
            return (
              <label
                className={`btn btn-outline-dark me-1 ${
                  link.active ? "active" : ""
                }`}
                onClick={() => {
                  let params = {
                    ...filter,
                    page: link.label,
                  };

                  setLoading(true);
                  setFilter({
                    ...params,
                  });

                  fetch(setData, params, "/eventos", null, setLoading);
                }}
              >
                {link.label}
              </label>
            );
          })}
        </div>
      </div>

      <div className="tab-content" id="eventosTabContent">
        <div className="tab-pane fade" id="anteriores" role="tabpanel">
          <div className="card">
            <div className="card-body text-center py-5">
              <p className="text-muted">
                No hay eventos anteriores para mostrar.
              </p>
            </div>
          </div>
        </div>

        <div
          className="tab-pane fade show active"
          id="proximos"
          role="tabpanel"
        >
          <div
            className="card d-none d-lg-block"
            style={{
              marginRight: "10vw",
              marginLeft: "10vw",
            }}
          >
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="table-light">
                  <tr>
                    <th>ID</th>
                    <th>TÍTULO</th>
                    <th>ENTRADAS VENDIDAS</th>
                    <th>FECHAS</th>
                    <th>CATEGORÍAS</th>
                    <th>RESPONSABLE</th>
                    <th>CREADO</th>
                    <th>ESTADO</th>
                    <th>ACCIONES</th>
                  </tr>
                </thead>
                <tbody>
                  {data.data.map((evento) => {
                    return (
                      <tr>
                        <td className="fw-semibold">#{evento.id}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            <img
                              src={`https://www.antesala.com.ar/assets/img/eventos/${evento.imagen}`}
                              alt="Evento"
                              className="rounded me-3"
                              width="48"
                              height="48"  
                            />
                            <span className="fw-medium">{evento.nombre}</span>
                          </div>
                        </td>
                        <td>
                          <div className="fw-semibold text-success">
                            $
                            {`${parseFloat(
                              evento.reportes_sum_total ?? 0
                            ).toLocaleString("es-AR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}`}
                          </div>
                          <small className="text-muted">
                            <i className="bi bi-people me-1"></i>
                            {evento.reportes_sum_cantidad ?? 0}
                          </small>
                        </td>
                        <td>
                          <small>{nextDate(evento.fechas)}</small>
                        </td>
                        <td>
                          {evento.categorias.map((categoria) => {
                            return (
                              <span className="badge bg-light text-dark border me-1">
                                {categoria.nombre}
                              </span>
                            );
                          })}
                        </td>
                        <td>{evento.nombre_sitio}</td>
                        <td>
                          <small>
                            {format(
                              new Date(evento.created_at),
                              "dd/M/yyyy"
                            ).toString()}
                          </small>
                        </td>
                        <td>
                          <div className="dropdown">
                            <button
                              className="btn text-white border fw-normal GothamBold px-3 py-2 fs-10 dropdown-toggle"
                              style={{ borderRadius: "10px" }}
                              type="button"
                              id="dropdownMenuButton1"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              {Status(evento.status)}
                            </button>
                            <ul
                              className="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <label className="btn m-0 p-0">
                                  <i className="text-success mx-1 bi bi-check-circle-fill"></i>
                                  Activar
                                  <button
                                    className="d-none"
                                    name="status"
                                    onClick={(event) =>
                                      onClick(event, {
                                        evento: evento,
                                        status: 1,
                                      })
                                    }
                                  ></button>
                                </label>
                              </li>
                              <li>
                                <label className="btn m-0 p-0">
                                  <i className="text-secondary mx-1 bi bi-slash-circle-fill"></i>
                                  Pausar
                                  <button
                                    className="d-none"
                                    name="status"
                                    onClick={(event) =>
                                      onClick(event, {
                                        evento: evento,
                                        status: 2,
                                      })
                                    }
                                  ></button>
                                </label>
                              </li>
                              <li>
                                <label className="btn m-0 p-0">
                                  <i className="text-info mx-1 bi bi-recycle"></i>
                                  Borradores
                                  <button
                                    className="d-none"
                                    name="status"
                                    onClick={(event) =>
                                      onClick(event, {
                                        evento: evento,
                                        status: 4,
                                      })
                                    }
                                  ></button>
                                </label>
                              </li>

                              <li>
                                <label className="btn m-0 p-0">
                                  <i className="text-danger mx-1 bi bi-trash"></i>
                                  Eliminar
                                  <button
                                    className="d-none"
                                    name="status"
                                    onClick={(event) =>
                                      onClick(event, {
                                        evento: evento,
                                        status: 3,
                                      })
                                    }
                                  ></button>
                                </label>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <label
                            className={`btn btn-sm btn-outline-secondary me-1 ${
                              VerifyPermits(user, data.permisos ?? []).boleteria
                                ? ""
                                : "d-none"
                            }`}
                          >
                            <i className="bi bi-pencil-square"></i>
                            <button
                              className="d-none"
                              name="editar-evento"
                              onClick={(e) => onClick(e, evento.id)}
                            ></button>
                          </label>

                          <label
                            className={`btn btn-sm btn-outline-dark  ${
                              VerifyPermits(user, data.permisos ?? []).edicion
                                ? ""
                                : "d-none"
                            }`}
                          >
                            <i class="bi bi-ticket"></i>
                            <button
                              className="d-none"
                              onClick={() => {
                                window.location.href = `/dashboard/boleteria/${evento.id}`;
                              }}
                            ></button>
                          </label>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          <div className="d-lg-none">
            <div className="card mb-3">
              {data.data.map((evento) => {
                return (
                  <div className="row g-0 mb-3">
                    <div className="col-4">
                      <div className="position-relative" style={{height: "230px"}}>
                        <img
                        src={`https://www.antesala.com.ar/assets/img/eventos/${evento.imagen}`}
                        className="img-fluid h-100 object-fit-cover"
                        alt="Evento"
                      />
                      </div>
                    </div>
                    <div className="col-8">
                      <div className="card-body p-3">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div className="flex-grow-1">
                            <h6 className="card-title mb-1 lh-sm">
                              {evento.nombre}
                            </h6>
                            <small className="text-muted">#{evento.id}</small>
                          </div>
                          <div className="dropdown">
                            <button
                              className="btn btn-sm btn-outline-secondary"
                              data-bs-toggle="dropdown"
                            >
                              <i className="bi bi-three-dots"></i>
                            </button>
                            <ul className="dropdown-menu">
                              <li>
                                <label
                                  className={`btn btn-sm border-0 me-1 ${
                                    VerifyPermits(user, data.permisos ?? [])
                                      .boleteria
                                      ? ""
                                      : "d-none"
                                  }`}
                                >
                                  <i className="bi bi-pencil-square me-1"></i>
                                  Editar
                                  <button
                                    className="d-none"
                                    name="editar-evento"
                                    onClick={(e) => onClick(e, evento.id)}
                                  ></button>
                                </label>
                              </li>
                              <li>
                                <label
                                  className={`btn btn-sm border-0  ${
                                    VerifyPermits(user, data.permisos ?? [])
                                      .edicion
                                      ? ""
                                      : "d-none"
                                  }`}
                                >
                                  <i class="bi bi-ticket me-1"></i>
                                  Boleteria
                                  <button
                                    className="d-none"
                                    onClick={() => {
                                      window.location.href = `/dashboard/boleteria/${evento.id}`;
                                    }}
                                  ></button>
                                </label>
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div className="row g-2 mb-2">
                          <div className="col-6">
                            <small className="text-muted">Ingresos:</small>
                            <div className="fw-semibold text-success small">
                              $
                              {`${parseFloat(
                                evento.reportes_sum_total ?? 0
                              ).toLocaleString("es-AR", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`}
                            </div>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">Entradas:</small>
                            <div className="fw-medium small">
                              {evento.reportes_sum_cantidad ?? 0}
                            </div>
                          </div>
                        </div>

                        <div className="mb-2">
                          {evento.categorias.map((categoria) => {
                            return (
                              <span
                                className="badge bg-light text-dark border me-1"
                                style={{ fontSize: "0.7rem" }}
                              >
                                {categoria.nombre}
                              </span>
                            );
                          })}
                        </div>

                        <div className="d-flex justify-content-between align-items-center">
                          <span
                            className="badge bg-success me-2"
                            style={{ fontSize: "0.7rem" }}
                          >
                            {StatusText(evento.status)}
                          </span>
                        </div>
                          <small className="text-muted">
                            {nextDate(evento.fechas)}
                          </small>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div
        className="d-none d-md-flex flex-column flex-sm-row justify-content-between align-items-center mt-4"
        style={{
          marginRight: "10vw",
          marginLeft: "10vw",
        }}
      >
        <div className="mb-2 mb-sm-0">
          <small className="text-muted">
            Mostrando <span className="fw-medium">EVENTOS {data?.total}</span>
          </small>
        </div>

        <div>
          {data.links.map((link) => {
            if (link.label == "&laquo; Previous") {
              return (
                <label
                  className={`btn btn-outline-dark me-1 ${
                    link.active ? "active" : ""
                  } ${link.url ? "" : "disabled"}`}
                  onClick={() => {
                    let params = {
                      ...filter,
                      page: data.current_page - 1,
                    };

                    setLoading(true);
                    setFilter({
                      ...params,
                    });

                    fetch(setData, params, "/eventos", null, setLoading);
                  }}
                >
                  <i class="bi bi-chevron-left"></i>
                  ANTERIOR
                </label>
              );
            }
            if (link.label == "Next &raquo;") {
              return (
                <label
                  className={`btn btn-outline-dark ${
                    link.active ? "active" : ""
                  } ${link.url ? "" : "disabled"}`}
                  onClick={() => {
                    let params = {
                      ...filter,
                      page: data.current_page + 1,
                    };

                    setLoading(true);
                    setFilter({
                      ...params,
                    });

                    fetch(setData, params, "/eventos", null, setLoading);
                  }}
                >
                  SIGUIENTE
                  <i class="bi bi-chevron-right"></i>
                </label>
              );
            }
            return (
              <label
                className={`btn btn-outline-dark me-1 ${
                  link.active ? "active" : ""
                }`}
                onClick={() => {
                  let params = {
                    ...filter,
                    page: link.label,
                  };

                  setLoading(true);
                  setFilter({
                    ...params,
                  });

                  fetch(setData, params, "/eventos", null, setLoading);
                }}
              >
                {link.label}
              </label>
            );
          })}
        </div>
      </div>

      <div className="d-flex d-md-none flex-column flex-sm-row justify-content-between align-items-center mt-4">
        <div className="mb-2 mb-sm-0">
          <small className="text-muted">
            Mostrando <span className="fw-medium">EVENTOS {data?.total}</span>
          </small>
        </div>

        <div>
          {data.links.map((link) => {
            if (link.label == "&laquo; Previous") {
              return (
                <label
                  className={`btn btn-outline-dark me-1 ${
                    link.active ? "active" : ""
                  } ${link.url ? "" : "disabled"}`}
                  onClick={() => {
                    let params = {
                      ...filter,
                      page: data.current_page - 1,
                    };

                    setLoading(true);
                    setFilter({
                      ...params,
                    });

                    fetch(setData, params, "/eventos", null, setLoading);
                  }}
                >
                  <i class="bi bi-chevron-left"></i>
                </label>
              );
            }
            if (link.label == "Next &raquo;") {
              return (
                <label
                  className={`btn btn-outline-dark ${
                    link.active ? "active" : ""
                  } ${link.url ? "" : "disabled"}`}
                  onClick={() => {
                    let params = {
                      ...filter,
                      page: data.current_page + 1,
                    };

                    setLoading(true);
                    setFilter({
                      ...params,
                    });

                    fetch(setData, params, "/eventos", null, setLoading);
                  }}
                >
                  <i class="bi bi-chevron-right"></i>
                </label>
              );
            }

            return (
              <label
                className={`btn btn-outline-dark me-1 ${
                  link.active ? "active" : ""
                }`}
                onClick={() => {
                  let params = {
                    ...filter,
                    page: link.label,
                  };

                  setLoading(true);
                  setFilter({
                    ...params,
                  });

                  fetch(setData, params, "/eventos", null, setLoading);
                }}
              >
                {link.label}
              </label>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TablaEventos;
